// VALIDATION RULES
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MIN_SCORE = 1;
